module.exports = __webpack_public_path__ + "static/media/icon-retiro.097a11d6.svg";